import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M14.376 15.829a7.125 7.125 0 1 1 1.104-1.017l5.43 5.429a.3.3 0 0 1 0 .424 1.2 1.2 0 0 1-1.697 0l-4.837-4.836Zm1.376-5.72a5.625 5.625 0 1 0-11.25 0 5.625 5.625 0 0 0 11.25 0Z" }));
export {
  a as default
};
//# sourceMappingURL=search-icon-vDsiFO-G.js.map
